<template>
    <div>
      <b-modal id="modal_reservaInfo" size="lg" :title="titulo"
          hide-header ok-only content-class="shadow"
          button-size="sm" centered ok-title="Cerrar" ok-variant="outline-primary">

          <reservaInfo/>

      </b-modal>
    </div>
  </template>

  <script>
  import reservaInfo from '@/components/reservaInfo.vue'
  export default {
    components: {
        reservaInfo,
    },
    data() {
      return {
          titulo: "RESERVA"
      }
    },
    computed: {
    },
    methods: {
        close() {
          //alert('cerrar');
          this.hideModal();
        },
    }
  }
  </script>
